module.exports = __webpack_public_path__ + "img/caretUp.93c9427e.svg";